const DEFAULT_API_BASE_URL = '/api';
const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1']);

const trimTrailingSlash = (value: string): string => value.replace(/\/$/, '');

const resolveApiBaseUrl = (): string => {
  const configuredUrl = (import.meta as any).env?.VITE_API_URL?.trim();

  if (!configuredUrl) {
    return DEFAULT_API_BASE_URL;
  }

  const normalizedUrl = trimTrailingSlash(configuredUrl);

  if (typeof window === 'undefined') {
    return normalizedUrl;
  }

  try {
    const resolvedUrl = new URL(normalizedUrl, window.location.origin);
    const currentHostIsLocal = LOCAL_HOSTS.has(window.location.hostname);
    const targetHostIsLocal = LOCAL_HOSTS.has(resolvedUrl.hostname);

    if (!currentHostIsLocal && targetHostIsLocal) {
      return DEFAULT_API_BASE_URL;
    }

    if (resolvedUrl.origin === window.location.origin) {
      return trimTrailingSlash(resolvedUrl.pathname) || DEFAULT_API_BASE_URL;
    }
  } catch {
    return normalizedUrl;
  }

  return normalizedUrl;
};

export const API_BASE_URL = resolveApiBaseUrl();